import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-person-modal-prompt', (fragmentEl) => {
    const isEditMode = document.body.classList.contains('has-edit-mode-menu');
    const promptBtns = fragmentEl.querySelectorAll<HTMLButtonElement>(
        '[command="show-modal"], .chroa-person-modal-prompt__button, .chroa-person-modal-prompt--link'
    );

    if (isEditMode) {
        promptBtns.forEach((btn) => {
            btn.removeAttribute('command');
            btn.removeAttribute('commandfor');
        });
        return;
    }

    promptBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetId = btn.dataset.targetModal || btn.getAttribute('commandfor');
            if (!targetId) return;

            const targetModal = document.getElementById(targetId) as HTMLDialogElement | null;
            if (targetModal && typeof targetModal.showModal === 'function') {
                targetModal.showModal();
            }
        });
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
